import { isAnyOf, type Middleware } from '@reduxjs/toolkit';
import { logout, sessionIdentityChanged } from '../auth/authSlice';

const clearers = new Set<() => void>();

/** Register state that lives outside Redux but still belongs to the signed-in account. */
export const registerChatSessionClearer = (
  clearer: () => void
): (() => void) => {
  clearers.add(clearer);
  return () => clearers.delete(clearer);
};

/** Clear every registered companion resource before the logout action reaches reducers. */
export const clearChatSessionLifetime = (): void => {
  clearers.forEach((clear) => clear());
};

const isSessionEnd = isAnyOf(logout, sessionIdentityChanged);

/**
 * Runs outside reducers so module-store listeners cannot notify React while a
 * Redux reducer is executing. It imports no companion runtime itself: modules
 * register only after they have loaded.
 */
export const chatSessionLogoutMiddleware: Middleware =
  () => (next) => (action) => {
    // Another account's session clears the companion like a sign-out.
    if (isSessionEnd(action)) {
      clearChatSessionLifetime();
    }

    return next(action);
  };
